var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tw-flex tw-justify-center tw-items-center tw-bg-transparent tw-rounded-full tw-h-10 tw-w-10 disabled:tw-opacity-30 disabled:hover:tw-cursor-not-allowed",attrs:{"disabled":_vm.disabled},on:{"click":(e) => _vm.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }